import React from 'react';
import { Route, Switch } from 'react-router';
import Scan from './Scan';
import SecureRoute from '../secure-route/SecureRoute';

export default function ScanContainerRoutes() {
 return <Switch>
    <SecureRoute path="/scan" component={Scan} />
  </Switch>
}